import { Dialog, Grid, List,Popup,Selector,Tabs } from "antd-mobile"
import React, { useCallback, useEffect, useImperativeHandle, useRef, useState } from 'react'
import { init, dispose } from 'klinecharts'

import { 
    ListView,
    CoinHeaderView,
    TabsView,
    LoadView,
    CoinImgView,
    TradeButtonView,
    InputView,
    EllipsisView,
} from "../factory/ViewUtil";

import { 
    CellStateView
 } from "../factory/CellViews";
import { isLogin, RequestTradeSecondFutures, RequsetKline, SendTradeSecondFutures } from "../../NetworkFactory";
import { BigDecimalZero, DecimalComparedToZero, DecimalConvert, FullURL, ToastClear, ToastContent, ToastLoading, ToDate4, TradeLightColor, TradeLightValueColor } from "../factory/FactoryUtil";
import { MoreR4Icon } from "../icons";
import { 
    DownFill,
} from 'antd-mobile-icons';
import { RefreshAssets } from "../assets/AssetsManager";

 // # k显示周期
const tabItems = [
    { key: 'MIN1', title: '1Min' },
    { key: 'MIN5', title: '5Min' },
    { key: 'MIN30', title: '30Min' },
    { key: 'MIN60', title: '1Hour' },
    { key: 'DAY1', title: '1Day' },
    { key: 'WEEK1', title: '1Week' }
]

// # views
//=========================================================
const TradToolBar = React.memo(({visibleTrade = false, symbol, openTime, openQuantity, logo, onClick, onMore = ()=> {}}) => {
    const onClickMore = (event) => {
        event.stopPropagation();
        onMore()
    }
    return (
        <div 
            onClick={onClick}
            style={{
                border : '1px #F1F1F1 solid',
                borderRadius : '100px',
                padding : '4px', 
                fontSize : '14px',
                display : 'flex',
                alignItems : 'center'
            }}>
            
            <CoinImgView style={{'--size' : '34px', '--border-radius' : '17px'}} src={FullURL(logo)}/>
            <div style={{width : '10px'}}></div>
            <div style={{flex : '1'}}>
                <div style={{fontWeight : 'bold'}}>{symbol}</div>
                <div style={{fontSize : '12px', color : '#999'}}>{openQuantity}・{openTime}s</div>
            </div>
            <div style={{display : 'flex', alignItems : 'center'}}>
                <div style={{transform : visibleTrade ? 'rotate(180deg)' : 'none'}}><DownFill/></div>
                <div style={{width : '20px'}}></div>
                <div onClick={onClickMore}><MoreR4Icon /></div>
            </div>
            <div style={{width : '15px'}}></div>
        </div>
    );
})

const TradeLineView = React.memo(({title = 'title'}) => {
    return (
        <List.Item style={{
            margin : '15px 0', 
            fontSize : '14px', 
            color : '#999'}}>{title}</List.Item>
    );
})

const SelectorView = React.memo(({data = [], value, onChange}) => {
    const color = '#6094FF'
    return (
        <List.Item>
            <Selector 
                columns={4}
                options={data} 
                value={[value]}
                showCheckMark={false} 
                onChange={onChange}
                style={{ 
                    '--padding' : '5px 0', 
                    '--border-radius' : '6px',
                    '--border': 'solid #F1F1F1 1px',
                    '--text-color' : '#A0A0A0',
                    '--checked-border': `solid ${color} 1px`,
                    '--checked-color' : color,
                    '--color' : 'transparent',
                    '--checked-text-color' : '#FFF',
                    fontSize : '14px'}} 
            />
        </List.Item>
    )
})

const OrderItemView = React.memo(({data}) => {
    const gap = 6
    return (
        <List.Item className="cellCardBorder" style={{fontSize : '13px'}}>
            <Grid columns={3} gap={gap} style={{color : '#999', alignItems : 'center'}}>
                <Grid.Item><EllipsisView rows={2} content='Quantity/Secs' /></Grid.Item>
                <Grid.Item><EllipsisView rows={2} content='Purchase price' /></Grid.Item>
                <Grid.Item style={{textAlign : 'right'}}><EllipsisView rows={2} content='Closed price' /></Grid.Item>
            </Grid>
            <Grid columns={3} gap={gap} style={{alignItems : 'center'}}>
                <Grid.Item><EllipsisView rows={2} content={`${data.amount}/${data.secs}s`} /></Grid.Item>
                <Grid.Item><EllipsisView rows={2} content={`${data.open_price}`} /></Grid.Item>
                <Grid.Item style={{textAlign : 'right'}}><EllipsisView rows={2} content={data.closed_price} /></Grid.Item>
            </Grid>

            <Grid columns={3} gap={gap} style={{color : '#999', marginTop : '10px', alignItems : 'center'}}>
                <Grid.Item><EllipsisView rows={2} content='Buy way'/></Grid.Item>
                <Grid.Item><EllipsisView rows={2} content='Profit and loss' /></Grid.Item>
                <Grid.Item style={{textAlign : 'right'}}><EllipsisView rows={2} content='Time' /></Grid.Item>
            </Grid>
            <Grid columns={3} gap={gap} style={{alignItems : 'center'}}>
                <Grid.Item><EllipsisView rows={2} content={`${data.symbol} ${data.type === 0 ? '↑' : '↓'}`} style={{color : TradeLightValueColor(data.type, 0)}}/></Grid.Item>
                <Grid.Item><EllipsisView rows={2} content={`${data.profits}`} style={{color : TradeLightColor(data.profits)}}/></Grid.Item>
                <Grid.Item style={{textAlign : 'right'}}><EllipsisView rows={2} content={ToDate4(data.closedDate)} /></Grid.Item>
            </Grid>
        </List.Item>
    )
})

const ListItemView = React.memo(({data}) => {
    const gap = 6
    return (
        <List.Item className="cellCardBorder" style={{fontSize : '13px'}}>
            <Grid columns={3} gap={gap} style={{color : '#999', alignItems : 'center'}}>
                <Grid.Item><EllipsisView rows={2} content='Quantity' /></Grid.Item>
                <Grid.Item><EllipsisView rows={2} content='Purchase price' /></Grid.Item>
                <Grid.Item style={{textAlign : 'right'}}><EllipsisView rows={2} content='Current price' /></Grid.Item>
            </Grid>
            <Grid columns={3} gap={gap} style={{alignItems : 'center'}}>
                <Grid.Item><EllipsisView rows={2} content={`${data.amount}`} /></Grid.Item>
                <Grid.Item><EllipsisView rows={2} content={`${data.open_price}`} /></Grid.Item>
                <Grid.Item style={{textAlign : 'right'}}><EllipsisView rows={2} content={data.market_price} /></Grid.Item>
            </Grid>

            <Grid columns={3} gap={gap} style={{color : '#999', marginTop : '10px', alignItems : 'center'}}>
                <Grid.Item><EllipsisView rows={2} content='Symbole'/></Grid.Item>
                <Grid.Item><EllipsisView rows={2} content='Profit and loss' /></Grid.Item>
                <Grid.Item style={{textAlign : 'right'}}><EllipsisView rows={2} content='Closing secs' /></Grid.Item>
            </Grid>
            <Grid columns={3} gap={gap} style={{alignItems : 'center'}}>
                <Grid.Item><EllipsisView rows={2} content={`${data.symbol} ${data.type === 0 ? '↑' : '↓'}`} style={{color : TradeLightValueColor(data.type, 0)}} /></Grid.Item>
                <Grid.Item><EllipsisView rows={2} content={`${data.profits}`} style={{color : TradeLightColor(data.profits)}}/></Grid.Item>
                <Grid.Item style={{textAlign : 'right'}}><EllipsisView rows={2} content={`${data.secs}`} /></Grid.Item>
            </Grid>
        </List.Item>
    )
})

//=========================================================

export const SecondFuturesTradeViewController = React.forwardRef((props, ref) => {
    
    const updateSymbolData = (data) => {
        setSymbolData(data)
        setSymbol(data.symbol)
    }

    const currentSymbolData = () => {
        return symbolData
    }

    //将子组件的方法 暴露给父组件
    useImperativeHandle(ref, () => ({
        currentSymbolData, updateSymbolData
    }))

    // # 读取缓存值或默认值
    const [symbol, setSymbol] = useState(localStorage.getItem('s_f_symbol') || 'BTC/USDT');
    const [symbolData, setSymbolData] = useState({
        symbol : symbol,
        open : '0.00',
        close : '0.00', 
        high : '0.00', 
        low : '0.00'
    });
    
    const [dataSource, setDataSource] = useState([]);
    const [stateCode, setStateCode] = useState(isLogin() ? -1 : 2);
    const [orderType, setOrderType] = useState(true);

    const [chartView, setChartView] = useState(null);
    const [isLoading, setLoading] = useState(true);
    
    const [timeInterval, setTimeInterval] = useState(tabItems[0].key);

    const [visibleTrade, setVisibleTrade] = useState(false);

    const [tradeMode, setTradeMode] = useState('USDT');
    const [openQuantity, setOpenQuantity] = useState('10');
    const [customOpenQuantity, setCustomOpenQuantity] = useState('')
    const [openTime, setOpenTime] = useState('30');
    

    const borderColor = '#F6F6F6';

    const klineSleep = 3000
    
    //=========================================================
    // # 刷新k线
    const timeoutKlineRef = useRef(null);
    const clearKlineTimeout = () => {
        clearTimeout(timeoutKlineRef.current)
        timeoutKlineRef.current = null
    }
    const refreshKlineData = () => {
        clearKlineTimeout()
        const isUpdate = chartView.getDataList().length > 0
        RequsetKline(symbol, timeInterval, isUpdate).then(response => {
            const result = response.data
            if(!isUpdate) {
                let data = []
                let kline = result.kline
                for(const item in kline) {
                    let value = kline[item]
                    data.push( { 
                        close: value.close,
                        high: value.high, 
                        low: value.low, 
                        open: value.open, 
                        timestamp: parseInt(value.id + '000'), 
                        volume: value.vol,
                        amount : value.amount
                    })
                }
                chartView.clearData()
                chartView.applyNewData([...data].reverse(), true)
                setLoading(false)
            }
            else {
                let kline = result.kline
                let data = { 
                    close: kline.close,
                    high: kline.high, 
                    low: kline.low, 
                    open: kline.open, 
                    timestamp: parseInt(kline.id + '000'), 
                    volume: kline.vol,
                    amount : kline.amount
                }
                chartView.updateData(data)
            }

            // # 执行
            const id = setTimeout(() => {
                refreshKlineData()
            }, klineSleep);
            timeoutKlineRef.current = id;
        })
    }
    //=========================================================

    //=========================================================
    // # 初始化k线视图
    useEffect(() => {
        const chart = init('chart');
        chart.setStyles({
            grid: {horizontal: {style : 'solid', color : borderColor }, vertical: { style : 'solid', color : borderColor}},
            candle : {tooltip : {showRule : 'follow_cross', showType : 'rect',
                    custom : (data) => {
                        return [
                            { title: 'Time: ',  value: '{time}' }, 
                            { title: 'Open: ',    value: '{open}' }, 
                            { title: 'Hight: ',    value: '{high}' },
                            { title: 'Low: ',    value: '{low}' },
                            { title: 'Close: ',    value: '{close}' },
                            { title: 'Amount: ',    value: DecimalConvert(data.current.amount) + '' }
                        ]
                    },
                    rect : {
                        borderSize: 0,
                        color : 'rgba(0, 0, 0, 0.76)'
                    },
                    text : {
                        color : '#FFFFFF'
                    }
                }
            },
            indicator : {tooltip : { showName : false } },
            yAxis : {inside : true, axisLine : { show : false }},
            xAxis : {axisLine : { show : true, color : borderColor }, tickLine : {length : 0}},
            separator : {color : borderColor, fill: false},
        })
        chart.createIndicator({ name : 'MA', calcParams : [5, 10, 30]}, true, { id: 'candle_pane', dragEnabled: false,  gap : {top : 60}, height: 60, axisOptions: {  scrollZoomEnabled: false } })
        chart.createIndicator({ name : 'VOL', calcParams : [5, 10]}, true, { dragEnabled: false, height: 60, axisOptions: { scrollZoomEnabled: false } })
        chart.createIndicator({ name : 'MACD'},  true, { dragEnabled: false, height: 60, axisOptions: { scrollZoomEnabled: false } })
        chart.zoomAtCoordinate(1)
        setChartView(chart)
        return () => {
            dispose('chart')
        }
    }, []);  // eslint-disable-line react-hooks/exhaustive-deps
    //=========================================================

    // # 监听变化刷新k线
    useEffect(() => {
        if(chartView) {
            chartView.clearData()
            setLoading(true)
            refreshKlineData()
        }
    }, [chartView, symbol, timeInterval]) // eslint-disable-line react-hooks/exhaustive-deps
    // # 符号变化保存
    useEffect(() => {
        if(symbol) {
            localStorage.setItem('s_f_symbol', symbol)
        }
    }, [symbol]) // eslint-disable-line react-hooks/exhaustive-deps
    
    //=========================================================

    //=========================================================
    // # 市场信息
    useEffect(() => {
        return () => {
            clearKlineTimeout()
        }
    }, []);  // eslint-disable-line react-hooks/exhaustive-deps
    //=========================================================
   
    //=========================================================
     // # 请求订单数据
    const requestOrder = useCallback(() => {
        if(isLogin()) {
            setStateCode(3)
            const type = orderType ? 1 : 0
            RequestTradeSecondFutures().then(response => {
                const data = response.data.data || []
                let tempData = []
                data.forEach(item => {
                    if(item.status === type) {
                        tempData.push(item)
                    }
                })
                setDataSource(tempData)
                setStateCode(tempData.length > 0 ? -1 : 1)
                
            }).catch(()=> {
                setStateCode(1)
            })
        }
    }, [orderType]) // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        requestOrder()
    }, [orderType]);  // eslint-disable-line react-hooks/exhaustive-deps
    //=========================================================

    const goRecharge = () => {
        Dialog.confirm({
            content : <div style={{textAlign : 'center', fontWeight : 'bold', fontSize : '17px'}}>Insufficient balance, please recharge</div>,
            cancelText : 'Cancel',
            closeOnMaskClick: true,
            confirmText : 'Recharge',
            onConfirm: () => {
                props.navpush('/recharge')
            }
        })
    }

    const postBuy = (up = true) => {
        if(!isLogin()) {
            return
        }
        
        if(!symbol) {
            ToastContent('Symbol invalid')
            return
        }

        // # 市场单价
        const price = symbolData.close
        if(DecimalComparedToZero(price) <= 0) {
            ToastContent('No market price')
            return
        }

        // # 交易模式
        if(!tradeMode) {
            ToastContent('Trade mode invalid')
            return
        }

        // # 秒数
        if(!openTime) {
            ToastContent('Open time invalid')
            return
        }

        // # 购买数量
        const amount = customOpenQuantity.length > 0 ? customOpenQuantity : openQuantity
        if(DecimalComparedToZero(amount) <= 0) {
            ToastContent('Open ouantity invalid')
            return
        }

        // # 发起请求
        ToastLoading(up ? 'Buying up' : 'Buying down')
        const data = {
            symbol : symbol,
            amount : BigDecimalZero(amount).toString(),
            secs : openTime
        }
        SendTradeSecondFutures(up, data).then(response => {
            ToastClear()
            setVisibleTrade(false)
            const {status} = response.data || {}
            if(status === -102) {
                // # 需要充值
                goRecharge()
            }
            else if(status === -405) {
                ToastContent('You have been banned from trading')
            }
            else if(status === 200) {
                ToastContent('Success')
                requestOrder()
                // # 刷新资产
                RefreshAssets('3')
            }

        }).catch(()=> {
            ToastClear()
        })
    }
    
    const goLogin = useCallback(() => {
        props.navpush('/login')
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <div style={{padding : '0 18px'}}>
            <ListView>
                <List.Item style={{margin : '10px 0'}}>
                    <CoinHeaderView item={symbolData}/>
                </List.Item>
                <List.Item style={{margin : '10px 0'}}>
                    <TabsView fontSize='14px' onChange={(key)=>{setTimeInterval(key)}} activeKey={timeInterval}>
                        {tabItems.map(item => (
                            <Tabs.Tab title={item.title} key={item.key} />
                        ))}
                    </TabsView>
                </List.Item>
                <List.Item>
                    <div style={{position : 'relative'}}>
                        <div id="chart" style={{height : '320px', borderRadius : '6px', border : `1px ${borderColor} solid`}}></div>
                        {
                            isLoading ? (<div style={{
                                position : 'absolute', 
                                left : '0', 
                                top : '0', 
                                width : '100%',
                                height : '320px', 
                                background : '#FFF', 
                                zIndex : '2',
                                display : 'flex',
                                alignItems: 'center',
                                justifyContent : 'center'
                            }}>
                                <LoadView src={FullURL(symbolData.logo)}/>
                            </div>) : ''
                        }
                    </div>
                </List.Item>
                <List.Item style={{margin : '20px 0'}}>
                    <TradToolBar
                    openQuantity={customOpenQuantity.length > 0 ? customOpenQuantity : openQuantity}
                    openTime={openTime}
                    visibleTrade={visibleTrade}
                    onClick={()=>{setVisibleTrade(true)}}
                    onMore={()=>{props.visibleMarketPopup('3')}}
                    symbol={symbol} 
                    logo={symbolData.logo}/>
                </List.Item>

                <List.Item style={{margin : '0 0 20px 0'}}>
                    <TabsView activeKey={orderType ? '1' : '2'} onChange={(key)=>{
                        setDataSource([])
                        setOrderType(key === '1')
                    }}>
                        <Tabs.Tab title="Position list" key='1'/>
                        <Tabs.Tab title="Order record" key='2'/>
                    </TabsView>
                </List.Item>
                <CellStateView stateType={stateCode} onRefresh={requestOrder} goLogin={goLogin}/>
                {
                    dataSource.map((item, index) => (
                        orderType ? <ListItemView data={item} key={index}/> : <OrderItemView data={item} key={index}/>
                    ))
                }
            </ListView>

            <Popup
                    visible={visibleTrade}
                    onMaskClick = {()=>{setVisibleTrade(false)}}
                    bodyStyle={{
                        borderTopLeftRadius: '16px',
                        borderTopRightRadius: '16px',
                        fontSize : '17px',
                        color : '#000'
                    }}
                >
                    <div style={{padding : '10px'}}>
                        <TradToolBar 
                            openQuantity={customOpenQuantity.length > 0 ? customOpenQuantity : openQuantity}
                            openTime={openTime}
                            onClick={()=>{setVisibleTrade(!visibleTrade)}}
                            onMore={()=>{
                                props.visibleMarketPopup('3')
                                setVisibleTrade(false)
                            }}
                            visibleTrade={visibleTrade}
                            symbol={symbol} 
                            logo={symbolData.logo}/>
                    </div>
                    <div style={{height : '60vh', padding : '6px 15px', overflowY : 'scroll'}}>
                        <ListView>
                            <TradeLineView title='Trade Mode'/>
                            <SelectorView data={[
                                {label : 'USDT', value : 'USDT'}
                            ]} value={tradeMode} onChange={(val)=>{setTradeMode(val.length > 0 ? val[0] : '')}}/>
                            <TradeLineView title='Open Quantity'/>
                            <SelectorView data={[
                                {label : '10', value : '10'},
                                {label : '30', value : '30'},
                                {label : '50', value : '350'},
                                {label : '100', value : '100'},
                                {label : '300', value : '300'},
                                {label : '500', value : '500'},
                                {label : '1000', value : '1000'},
                                {label : '3000', value : '3000'},
                                {label : '5000', value : '5000'},
                                {label : '10000', value : '10000'},
                                {label : '50000', value : '50000'},
                                {label : '100000', value : '100000'},
                            ]} value={openQuantity} onChange={(val)=>{
                                setOpenQuantity(val.length > 0 ? val[0] : '');
                                setCustomOpenQuantity('')}}/>
                            <List.Item style={{marginTop : '20px'}}>
                                <InputView title='Custom open quantity' value={customOpenQuantity} onChange={val => {
                                    setCustomOpenQuantity(val);
                                    setOpenQuantity('')}} clearable color='#ccc'/>
                            </List.Item>

                            <TradeLineView title='Opening Time'/>
                            <SelectorView data={[
                                {label : '30s', value : '30'},
                                {label : '60s', value : '60'},
                                {label : '90s', value : '90'},
                                {label : '120s', value : '120'},
                                {label : '180s', value : '180'},
                            ]} value={openTime} onChange={(val)=>{setOpenTime(val.length > 0 ? val[0] : '')}}/>
    
                            <List.Item style={{margin : '40px 0'}}>
                                <Grid columns={2} gap={10}>
                                    <Grid.Item>
                                        <TradeButtonView onClick={()=>{postBuy(true)}} style={{background : '#08BF89'}}>Buy up</TradeButtonView>
                                    </Grid.Item>
                                    <Grid.Item>
                                        <TradeButtonView onClick={()=>{postBuy(false)}} style={{background : '#D92727'}}>Buy up</TradeButtonView>
                                    </Grid.Item>
                                </Grid>
                            </List.Item>
                        </ListView>
                    </div>
            </Popup>
        </div>
    )
})